/*
 * SmartScreens.ae - Klaviyo conversion tracking via Client Events API
 * Records "Clicked WhatsApp", "Clicked Phone", "Submitted RFP Form" for ALL
 * visitors (incl. anonymous) using Klaviyo public client endpoints + a persistent
 * visitor id. Uses keepalive so clicks that navigate away still send. Public id: U8QYFx.
 */
(function () {
  'use strict';
  var COMPANY = 'U8QYFx';
  var REV = '2024-10-15';
  var EV = 'https://a.klaviyo.com/client/events/?company_id=' + COMPANY;
  var PR = 'https://a.klaviyo.com/client/profiles/?company_id=' + COMPANY;

  function uuid() { try { if (window.crypto && crypto.randomUUID) return crypto.randomUUID(); } catch (e) {} return 'ssv-' + Date.now() + '-' + Math.random().toString(36).slice(2); }
  function lsGet(k) { try { return localStorage.getItem(k) || ''; } catch (e) { return ''; } }
  function lsSet(k, v) { try { localStorage.setItem(k, v); } catch (e) {} }
  function vid() { var v = lsGet('ss_kl_vid'); if (!v) { v = uuid(); lsSet('ss_kl_vid', v); } return v; }
  function getDevice() {
    var ua = navigator.userAgent || '';
    if (/iPad|Tablet|PlayBook|Silk/i.test(ua) || (/Android/i.test(ua) && !/Mobile/i.test(ua))) return 'Tablet';
    if (/Mobi|iPhone|iPod|Android.*Mobile|Windows Phone|BlackBerry/i.test(ua)) return 'Mobile';
    return 'Desktop';
  }
  function isBot() {
    try { if (navigator.webdriver) return true; } catch (e) {}
    var ua = (navigator.userAgent || '').toLowerCase();
    if (!ua) return true;
    return /bot|crawl|spider|slurp|headless|phantom|puppeteer|playwright|selenium|lighthouse|gtmetrix|pingdom|scrapy|curl|wget|python-requests|axios|facebookexternalhit|embedly|bytespider|ahrefsbot|semrushbot|dotbot|mj12bot|petalbot|yandexbot|bingbot|googlebot|applebot|duckduckbot/i.test(ua);
  }
  function getTZ() { try { return Intl.DateTimeFormat().resolvedOptions().timeZone || ''; } catch (e) { return ''; } }
  var SS_TZ_CC = {
    'Asia/Dubai':'United Arab Emirates','Asia/Muscat':'Oman','Asia/Riyadh':'Saudi Arabia','Asia/Qatar':'Qatar','Asia/Bahrain':'Bahrain','Asia/Kuwait':'Kuwait','Asia/Baghdad':'Iraq','Asia/Beirut':'Lebanon','Asia/Amman':'Jordan','Asia/Jerusalem':'Israel','Asia/Tehran':'Iran','Africa/Cairo':'Egypt','Asia/Kolkata':'India','Asia/Karachi':'Pakistan','Asia/Dhaka':'Bangladesh','Asia/Colombo':'Sri Lanka','Asia/Kathmandu':'Nepal','Asia/Manila':'Philippines','Asia/Singapore':'Singapore','Asia/Kuala_Lumpur':'Malaysia','Asia/Jakarta':'Indonesia','Asia/Bangkok':'Thailand','Asia/Shanghai':'China','Asia/Hong_Kong':'Hong Kong','Asia/Tokyo':'Japan','Asia/Seoul':'South Korea','Europe/London':'United Kingdom','Europe/Dublin':'Ireland','Europe/Paris':'France','Europe/Berlin':'Germany','Europe/Madrid':'Spain','Europe/Rome':'Italy','Europe/Amsterdam':'Netherlands','Europe/Brussels':'Belgium','Europe/Zurich':'Switzerland','Europe/Stockholm':'Sweden','Europe/Moscow':'Russia','Europe/Istanbul':'Turkey','America/New_York':'United States','America/Chicago':'United States','America/Denver':'United States','America/Los_Angeles':'United States','America/Phoenix':'United States','America/Toronto':'Canada','America/Vancouver':'Canada','America/Sao_Paulo':'Brazil','Australia/Sydney':'Australia','Australia/Melbourne':'Australia','Australia/Perth':'Australia','Africa/Johannesburg':'South Africa','Africa/Lagos':'Nigeria','Africa/Nairobi':'Kenya'
  };
  function getCountry() {
    var tz = getTZ();
    if (SS_TZ_CC[tz]) return SS_TZ_CC[tz];
    if (tz && tz.indexOf('/') !== -1) return tz.split('/').pop().replace(/_/g, ' ');
    return tz || 'Unknown';
  }

  function profileAttrs() {
    var a = { external_id: vid() };
    var e = lsGet('ss_kl_email'); if (e) a.email = e;
    var p = lsGet('ss_kl_phone'); if (p && /^\+\d{7,15}$/.test(p)) a.phone_number = p;
    return a;
  }
  function post(url, body) {
    try { fetch(url, { method: 'POST', keepalive: true, headers: { 'Content-Type': 'application/json', 'revision': REV }, body: JSON.stringify(body) }); } catch (e) {}
  }
  function sendEvent(name, props) {
    props = props || {};
    try { props.Device = getDevice(); } catch (e) {}
    try { props.Viewport = (window.innerWidth || 0) + 'x' + (window.innerHeight || 0); } catch (e) {}
    try { props.Country = getCountry(); } catch (e) {}
    try { props.Timezone = getTZ(); } catch (e) {}
    post(EV, { data: { type: 'event', attributes: {
      properties: props,
      metric: { data: { type: 'metric', attributes: { name: name } } },
      profile: { data: { type: 'profile', attributes: profileAttrs() } },
      time: new Date().toISOString()
    } } });
  }
  function identifyLead(email, phone, first, company) {
    if (email) lsSet('ss_kl_email', email);
    if (phone) lsSet('ss_kl_phone', phone);
    if (!email && !phone) return;
    var attrs = { external_id: vid() };
    if (email) attrs.email = email;
    if (phone && /^\+\d{7,15}$/.test(phone)) attrs.phone_number = phone;
    if (first) attrs.first_name = first;
    var props = {}; if (company) props.Company = company; if (phone && !attrs.phone_number) props.Phone = phone;
    if (Object.keys(props).length) attrs.properties = props;
    post(PR, { data: { type: 'profile', attributes: attrs } });
  }

  function pageBase() { return { PageURL: location.href, PageTitle: document.title }; }
  function isProductPage() { try { if (document.body && document.body.className && document.body.className.indexOf('template-product') !== -1) return true; } catch (e) {} return location.pathname.indexOf('/products/') !== -1; }
  function getProductTitle() {
    try { if (window.meta && window.meta.product && window.meta.product.title) return window.meta.product.title; } catch (e) {}
    try { if (window.ShopifyAnalytics && window.ShopifyAnalytics.meta && window.ShopifyAnalytics.meta.product && window.ShopifyAnalytics.meta.product.title) return window.ShopifyAnalytics.meta.product.title; } catch (e) {}
    try { var d = document.querySelector('[data-ss-product]'); if (d && d.getAttribute('data-ss-product')) return d.getAttribute('data-ss-product'); var h = document.getElementById('ssrq_product'); if (h && h.value) return h.value; } catch (e) {}
    if (isProductPage()) return (document.title || '').replace(/\s*[–\-]\s*SmartScreens\.ae\s*$/i, '').trim() || document.title;
    return document.title;
  }
  var WA = /(wa\.me|api\.whatsapp\.com|whatsapp\.com\/send)/i;
  function isWhatsApp(el) { if (!el) return false; var h = (el.getAttribute && (el.getAttribute('href') || '')) || ''; if (WA.test(h)) return true; var id = (el.id || '').toLowerCase(); var c = (el.className && el.className.toString ? el.className.toString() : '').toLowerCase(); if (id.indexOf('whatsapp') !== -1 || id === 'ssrqwa') return true; if (c.indexOf('whatsapp') !== -1 || c.indexOf('--wa') !== -1) return true; if (el.hasAttribute && el.hasAttribute('data-ss-wa')) return true; return false; }
  function waSource(el) { try { if (el.closest && el.closest('#ssrq')) return 'Request Popup'; if (el.closest && el.closest('.ss-fab')) return 'Global Button'; if ((el.id || '').toLowerCase() === 'ssrqwa') return 'Request Popup'; } catch (e) {} if (isProductPage()) return 'Product Page'; return 'Other'; }
  var lastWa = { ts: 0, key: '' };
  function waDeb(k) { var n = Date.now(); if (k === lastWa.key && (n - lastWa.ts) < 800) return false; lastWa.ts = n; lastWa.key = k; return true; }
  function fieldVal(form, sel) { for (var i = 0; i < sel.length; i++) { try { var el = form.querySelector(sel[i]); if (el && el.value && el.value.trim()) return el.value.trim(); } catch (e) {} } return ''; }

  function submitFromPopup(el) {
    var pop = (el.closest && el.closest('#ssrq')) || document.getElementById('ssrq'); if (!pop) return;
    var name = fieldVal(pop, ['#ssrq_name', '[name="contact[name]"]']);
    var email = fieldVal(pop, ['#ssrq_email', '[name="contact[email]"]']);
    var phone = fieldVal(pop, ['#ssrq_phone', '[name="contact[phone]"]']);
    var company = fieldVal(pop, ['#ssrq_company', '[name="contact[company]"]']);
    var req = fieldVal(pop, ['#ssrq_req', '[name="contact[body]"]']);
    var prod = fieldVal(pop, ['#ssrq_product', '[name="contact[product]"]']) || getProductTitle();
    if (email || phone) identifyLead(email, phone, name, company);
    var p = pageBase(); p.ProductTitle = prod; p.Requirement = req; p.Name = name; p.Company = company; p.FormType = 'Request Best Price (WhatsApp)';
    sendEvent('Submitted RFP Form', p);
  }

  document.addEventListener('click', function (e) {
    if (!e.isTrusted || isBot()) return;
    var el = e.target && e.target.closest ? e.target.closest('a,button') : null; if (!el) return;
    if (isWhatsApp(el)) {
      var src = waSource(el); var key = src + '|' + (el.id || el.className || '');
      if (waDeb(key)) { var p = pageBase(); p.Source = src; if (isProductPage()) p.ProductTitle = getProductTitle(); sendEvent('Clicked WhatsApp', p);
        if ((el.id || '').toLowerCase() === 'ssrqwa' || (el.closest && el.closest('#ssrq'))) submitFromPopup(el); }
      return;
    }
    var h = (el.getAttribute && el.getAttribute('href')) || '';
    if (h.toLowerCase().indexOf('tel:') === 0) { var p2 = pageBase(); p2.Number = h.replace(/^tel:/i, '').trim(); sendEvent('Clicked Phone', p2); return; }
  }, true);

  document.addEventListener('submit', function (e) {
    if (isBot()) return;
    var form = e.target; if (!form || form.nodeName !== 'FORM') return;
    var id = (form.id || '').toLowerCase(); var isRfp = (id === 'ssrqform'); var isDemo = (id === 'ssrequestlivedemoform'); var isContact = false;
    try { isContact = !!form.querySelector('input[name="form_type"][value="contact"], [name="contact[email]"], [name="contact[name]"]'); } catch (err) {}
    if (!isRfp && !isDemo && !isContact) return;
    var name = fieldVal(form, ['#ssrq_name', '#SSDemoName', '[name="contact[name]"]']);
    var email = fieldVal(form, ['#ssrq_email', '#SSDemoEmail', '[name="contact[email]"]', 'input[type="email"]']);
    var phone = fieldVal(form, ['#ssrq_phone', '#SSDemoPhone', '[name="contact[phone]"]', 'input[type="tel"]']);
    var company = fieldVal(form, ['#ssrq_company', '#SSDemoCompany', '[name="contact[company]"]']);
    var req = fieldVal(form, ['#ssrq_req', '#SSDemoMsg', '[name="contact[body]"]', 'textarea']);
    var prod = fieldVal(form, ['#ssrq_product', '[name="contact[product]"]']) || getProductTitle();
    if (email || phone) identifyLead(email, phone, name, company);
    var p = pageBase(); p.ProductTitle = prod; p.Requirement = req; p.Name = name; p.Company = company; p.FormType = isDemo ? 'Request Live Demo' : (isRfp ? 'Request Best Price' : 'Contact');
    sendEvent('Submitted RFP Form', p);
  }, true);
})();
